// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
This computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), 
is the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.
*/
.review-footer-container {
  display: flex;
  gap: 12px;
  padding-top: 16px;
  margin-top: auto;
}

.review-footer-container > * {
  flex: 1;
}
`, "",{"version":3,"sources":["webpack://./src/views/pages/manualReviewTab/components/ReviewFooter/ReviewFooter.css"],"names":[],"mappings":"AAAA;;;CAGC;AACD;EACE,aAAa;EACb,SAAS;EACT,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,OAAO;AACT","sourcesContent":["/*\nThis computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), \nis the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.\n*/\n.review-footer-container {\n  display: flex;\n  gap: 12px;\n  padding-top: 16px;\n  margin-top: auto;\n}\n\n.review-footer-container > * {\n  flex: 1;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
